import { api } from '../config/api';

export interface LedgerTotals {
  total_recorded: number;
  bank_confirmed: number;
  possible: number;
  pending: number;
  quote: number;
}
export interface LedgerRepairs { total: number; confirmed: number; }
export interface LedgerCounts {
  bank_confirmed: number; possible: number; pending: number; quote: number;
}
export interface CategoryRow {
  category: string; amount: number; confirmed: number; count: number;
}
export interface LineItem {
  id: number;
  date: string | null;
  vendor: string | null;
  description: string | null;
  amount: number;
  category: string | null;
  status: 'bank_confirmed' | 'possible' | 'pending' | 'quote';
  confidence: string | null;
  document_id: number | null;
  bank_date: string | null;
  bank_payee: string | null;
}
export interface PropertyLedger {
  property_id: number;
  property_name: string;
  address?: string;
  totals: LedgerTotals;
  counts: LedgerCounts;
  repairs: LedgerRepairs;
  categories: CategoryRow[];
  line_items: LineItem[];
}
export interface PropertySummaryRow {
  property_id: number;
  property_name: string;
  totals: LedgerTotals;
  repairs: LedgerRepairs;
  counts: LedgerCounts;
}
export interface LedgerSummary {
  portfolio: {
    totals: LedgerTotals;
    counts: LedgerCounts;
    repairs: LedgerRepairs;
    categories: CategoryRow[];
  };
  properties: PropertySummaryRow[];
}

export const getLedgerSummary = async (): Promise<LedgerSummary> =>
  (await api.get('/pocketsmith/ledger/summary')).data;

export const getPropertyLedger = async (id: number): Promise<PropertyLedger> =>
  (await api.get(`/pocketsmith/ledger/property/${id}`)).data;

export const runReconciliation = async () =>
  (await api.post('/pocketsmith/reconcile')).data;

// LLM off by default — rules cover the clean vendors; the LLM would force
// owner-transfers/credit-card rows into wrong buckets. Enable deliberately.
export const runCategorization = async (useLlm = false) =>
  (await api.post(`/categorizer/run?use_llm=${useLlm}`)).data;
